import { Paragraph, H2 } from '@sbab-ui/components'

const renovations = [
  { id: 1, name: 'Fönsterbyte' },
  { id: 2, name: 'Bergvärme' },
  { id: 3, name: 'Värmepump (luft/luft, frånluft, luft/vatten, mark)' },
  { id: 4, name: 'Solceller' },
  { id: 5, name: 'Fjärrvärme' },
  { id: 6, name: 'Tilläggsisolering/isolering av fasad, vind eller yttertak' },
  { id: 7, name: 'Från- och tilluftsventilation med värmeåtervinning' },
]

export default function EnergyRenovationBanner() {
  return (
    <div className="mt-10 px-2 py-8 md:mt-10 md:px-6">
      <H2 className="text-24 md:text-32 flex text-black">
        Vilka energirenoveringar kan jag få Kilowattlånet för?
      </H2>

      <ul className="ml-4 mt-6 list-disc">
        {renovations.map((renovation) => (
          <li key={renovation.id}>
            <Paragraph className="pl-3">{renovation.name}</Paragraph>
          </li>
        ))}
      </ul>
    </div>
  )
}
